<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>通知管理</el-breadcrumb-item>
            <el-breadcrumb-item>通知列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <el-row :gutter="20">
                <!--搜索与添加区域-->
                <el-col :span="4">
                    <el-input placeholder="请输入标题" v-model="queryInfo.title" clearable
                              @clear="getFirmWareEditionList">
                    </el-input>
                </el-col>
                <!--搜索按钮-->
                <el-col :span="3">
                    <el-button type="primary" icon="el-icon-search" @click="getFirmWareEditionList">{{$t('common.search')}}</el-button>
                </el-col>

                <el-col :span="2" style="float: right">
                    <el-button type="primary" icon="el-icon-plus" @click="openAddFirmWareEdition">{{$t('common.add')}}</el-button>
                </el-col>
            </el-row>
            <!--记录区域-->
            <el-table :data="firmWareEditionList.records" border stripe style="width: 100%" v-loading="loading">
                <el-table-column label="通知标题" prop="title" align="center"></el-table-column>
                <el-table-column label="发布者" prop="userName" align="center"></el-table-column>
                <el-table-column label="语言版本" prop="internationalVersion" align="center"></el-table-column>
                <el-table-column label="发布状态" prop="isPublish" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isPublish == 1" sortable type="success">发布</el-tag>
                        <el-tag v-else type="danger">未发布</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" sortable prop="creationTime" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" content="发布" placement="top" :enterable="false">
                        <el-switch
                                @change="changeoff($event,scope.row.id)"
                                v-model="value"
                                active-value="1"
                                inactive-value="0">
                        </el-switch>
                        </el-tooltip >
                        <!--删除-->
                        <el-tooltip style="margin-left: 15px" effect="dark" content="删除" placement="top" :enterable="false">
                            <el-button type="danger" icon="el-icon-delete" size="mini"
                                       @click="removeFirmWareEditionById(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="firmWareEditionList.total">
            </el-pagination>
        </el-card>

        <!--        添加数据弹框-->
        <el-dialog
                title="增加消息通知"
                :visible.sync="addDialogVisible"
                width="700px">
            <el-form :model="addFirmWareEdition" label-width="100px" :inline="true">
                <el-form-item label="通知标题" prop="versions">
                    <el-input v-model="addFirmWareEdition.title" style="width: 500px"
                              placeholder="通知标题"></el-input>
                </el-form-item>
                <el-form-item label="通知封面" style="height: 150px">
                    <el-upload
                            :action="baseUrl"
                            :limit="1"
                            list-type="picture"
                            :show-file-list="true"
                            :on-exceed="handleExceed"
                            :on-success="handleUploadSuccess1"
                            :file-list="fileList1">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="通知内容" prop="methodParams">
                    <el-input type="textarea" :rows="4" v-model="addFirmWareEdition.content"
                              placeholder="请输入通知内容"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="通知内容图片" style="height: 150px">
                    <el-upload
                            :action="baseUrl"
                            :limit="1"
                            list-type="picture"
                            :show-file-list="true"
                            :on-exceed="handleExceed"
                            :on-success="handleUploadSuccess2"
                            :file-list="fileList2">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <!--<el-form-item label="创建时间" prop="creationTime">-->
                <!--<el-date-picker-->
                <!--v-model="addFirmWareEdition.creationTime"-->
                <!--type="datetime"-->
                <!--value-format="yyyy-MM-dd HH:mm:ss"-->
                <!--placeholder="选择日期时间" style="width: 500px">-->
                <!--</el-date-picker>-->
                <!--</el-form-item>-->
                <el-form-item label="语言版本" prop="type">
                    <el-select v-model="addFirmWareEdition.internationalVersion" placeholder="请选择语言版本" style="width: 500px">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否发布" prop="isForce">
                    <el-radio-group v-model="addFirmWareEdition.isPublish" style="width: 500px">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="附件" style="height: 150px">
                    <el-upload
                            :action="baseUrl"
                            :limit="1"
                            :show-file-list="true"
                            :on-exceed="handleExceed"
                            :on-success="handleUploadSuccess"
                            :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addFirmWareEditionInfo">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "FirmWareEditionList",
        data() {
            return {
                value:0,
                appType:'',
                options: [
                    {
                        value: '英文',
                        label: '英文'
                    }, {
                        value: '中文',
                        label: '中文'
                    }
                ],
                addDialogVisible: false,
                baseUrl: "http://brix.zhengtusensor.com:8888/zhengtusensor/upload/FirmWareEdition",
                fileList: [],
                fileList1:[],
                fileList2:[],
                addFirmWareEdition: {
                    isForce: 1
                },
                loading: false,
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10,
                    title:""
                },
                firmWareEditionList: {
                    records: [],
                    total: 0
                },
            }
        },
        created() {
            this.getFirmWareEditionList();
        },
        methods: {
            changeoff(num,id){
                console.log(num)
                this.updateoff(num,id)
            },
            async updateoff(num,id){
                let params = {
                id:id,
                    isPublish:num
                };
                let {data: res} = await this.$http.post(`/appnotice/addAppNotice`, params);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.$message.success("修改成功")
                this.getFirmWareEditionList();
            },
            handleUploadSuccess(response, file, fileList) {
                this.fileList = fileList
            },
            handleUploadSuccess1(response, file, fileList) {
                this.fileList1 = fileList
            },
            handleUploadSuccess2(response, file, fileList) {
                this.fileList2 = fileList
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            async addFirmWareEditionInfo() {
                let ip = "http://brix.zhengtusensor.com:8888";
                let params = {};
                console.log(this.fileList)
                if (this.addFirmWareEdition.title == "" || this.addFirmWareEdition.title == undefined) {
                    this.$message.error("请输入标题")
                    return
                }
                if (this.fileList1.length == 0) {
                    this.$message.error("请上传封面")
                    return
                }
                if (this.addFirmWareEdition.content == "" || this.addFirmWareEdition.content == undefined) {
                    this.$message.error("请输入通知内容")
                    return
                }
                if (this.addFirmWareEdition.internationalVersion == "" || this.addFirmWareEdition.internationalVersion == undefined) {
                    this.$message.error("请选择语言版本")
                    return
                }
                 if(this.fileList.length >0){
                     this.addFirmWareEdition.attachment = ip + this.fileList[0].response.data;
                 }
                if(this.fileList1.length >0){
                    this.addFirmWareEdition.coverUrl = ip + this.fileList1[0].response.data;
                }
                if(this.fileList2.length >0){
                    this.addFirmWareEdition.imagesUrl = ip + this.fileList2[0].response.data;
                }
                this.addFirmWareEdition.userName=window.sessionStorage.getItem("username")
                this.addFirmWareEdition.userId=window.sessionStorage.getItem("userId")
                params = this.addFirmWareEdition;
                let {data: res} = await this.$http.post(`/appnotice/addAppNotice`, params);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.addDialogVisible = false
                this.getFirmWareEditionList()

            },
            openAddFirmWareEdition() {
                this.addFirmWareEdition = { isForce: 1}
                this.addDialogVisible = true
            },
            // 获取记录列表
            async getFirmWareEditionList() {
                this.loading = true
                let {data: res} = await this.$http.post(`/appnotice/selectPage`, this.queryInfo);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.firmWareEditionList.records = res.data.records;
                this.firmWareEditionList.total = res.data.total;
                this.loading = false
            },
            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getFirmWareEditionList()
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getFirmWareEditionList()
            },
            // 根据id删除记录信息
            async removeFirmWareEditionById(record) {
                // 弹框询问用户是否删除记录
                await this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除记录
                    const {data: res} = await this.$http.post(`/appnotice/deleteById`, record);
                    if (res.code !== 1) return this.$message.error("删除失败");
                    this.$message.success("删除成功");
                    // 重新获取记录列表
                    this.getFirmWareEditionList();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }

    .app .el-card {
        width: 99%;
    }
</style>
